module.exports = __webpack_public_path__ + "static/media/detail_0026_t.4e53f9c3.jpg";